// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"ac3b0fa9","705":"de61172e","762":"ca83bda3","803":"de61172e"}[chunkId] + ".chunk.css";
};